import React, { useEffect } from 'react';
import { Badge, Container } from 'react-bootstrap';
import { IModifierGroupsComponent } from '../../../models/try2Combo';
import { Accordion } from 'react-bootstrap';
import ItemModifierGroups from '../../../containers/try2/Customization/try2Customization/ingredients/ModifierGroups/ItemModifierGroups';
import { DO_NOT_SHOW } from '../../../constants';
import { IParams } from '../../../models/card';
import { IModifierGroups } from '../../../models/item.model';
import { isUserAuthorizedForTestingPayload } from '../../utils';
const styles: Record<string, React.CSSProperties> = {
  metaKeysContainer: {
    display: "inline-flex",
    gap: "0.5rem",
    marginLeft: "0.75rem",
    flexWrap: "wrap",
    verticalAlign: "middle",
  },

  metaKey: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 8px",
    borderRadius: "6px",
    backgroundColor: "#f4f6f8",
    border: "1px solid #e1e4e8",
    fontSize: "13px",
    lineHeight: 1.4,
  },

  metaKeyLabel: {
    color: "#6b7280",
    fontWeight: 500,
    textTransform: "lowercase",
  },

  metaKeyValue: {
    color: "#111827",
    fontWeight: 600,
    fontFamily:
      "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  },
};


const ModifierGroups: React.FC<IModifierGroupsComponent> = (
  props
): JSX.Element => {
  const {
    otherModifierJSXWithByDefaultAccordionControl,
    otherModifierJSXWithCustomAccordionControl,
  }: {
    otherModifierJSXWithByDefaultAccordionControl: JSX.Element[];
    otherModifierJSXWithCustomAccordionControl: JSX.Element;
  } = useGetModifierGroupsJSX(props);

  return (
    <>
      {props.isCreateYourOwnItem
        ? otherModifierJSXWithCustomAccordionControl
        : otherModifierJSXWithByDefaultAccordionControl}
    </>
  );
};

const useGetModifierGroupsJSX = (props: IModifierGroupsComponent) => {
  const {
    modifierGroups,
    selectedAddOns,
    selectedCore,
    isLimitExceed,
    handleClick,
    isItEdit,
    showCustomization,
    itemModifierItemModalWidth,
    isCreateYourOwnItem,
    modifierGroupScrolling,
    scrollToNextGroupOnExtendableSelection,
  }: IModifierGroupsComponent = props;

  const [openAccordions, setOpenAccordions] = React.useState<string[]>([
    ...modifierGroupScrolling.current.valForAccordian,
  ]);

  useEffect(() => {
    if (modifierGroupScrolling.current.scroll) {
      let scrollTimeoutId;
      clearTimeout(scrollTimeoutId);
      scrollTimeoutId = setTimeout(() => {
        modifierGroupScrolling.current.scroll();
        modifierGroupScrolling.current.scroll = null;
      }, 200);
    }
  }, [openAccordions]);

  useEffect(() => {
    if (
      modifierGroupScrolling.current.currentMissingIndex !== null &&
      openAccordions.findIndex(
        (value: string) =>
          value === modifierGroupScrolling.current.currentMissingIndex
      ) < 0
    ) {
      handleToggle(
        undefined,
        modifierGroupScrolling.current.currentMissingIndex,
        'modifier'
      );
      modifierGroupScrolling.current.currentMissingIndex = null;
    } else if (modifierGroupScrolling.current.currentMissingIndex !== null) {
      if (modifierGroupScrolling.current.scroll) {
        let scrollTimeoutId;
        clearTimeout(scrollTimeoutId);
        scrollTimeoutId = setTimeout(() => {
          modifierGroupScrolling.current.scroll();
          modifierGroupScrolling.current.scroll = null;
        }, 200);
      }
      modifierGroupScrolling.current.currentMissingIndex = null;
    }
  }, [modifierGroupScrolling.current.currentMissingIndex]);

  const handleToggle = (
    groupId: number | undefined,
    id: string,
    clickedOn: 'accordion' | 'modifier'
  ): void => {
    const indexOfCurrentId = openAccordions.indexOf(id);
    const newData = [...openAccordions];
    let openCurrentAccorion: any = null;
    if (groupId && indexOfCurrentId == -1) {
      openCurrentAccorion = scrollToNextGroupOnExtendableSelection(undefined, {
        name: clickedOn,
        groupId,
      });
    }
    if (
      (!groupId && indexOfCurrentId == -1) ||
      (indexOfCurrentId == -1 && openCurrentAccorion?.status == false)
    ) {
      newData.push(id);
    } else {
      newData.splice(indexOfCurrentId, 1);
    }
    setOpenAccordions(newData);
  };

  const otherModifierJSXWithByDefaultAccordionControl: JSX.Element[] =
    modifierGroups &&
    modifierGroups.map(
      (ingredients: IModifierGroups, index: number): JSX.Element => {
        const label: string = ingredients?.label?.toLowerCase();
        return (
          <React.Fragment key={ingredients.id}>
            {showGroup(ingredients) ? (
              <Container fluid>
                <Accordion
                  defaultActiveKey={[
                    ...modifierGroupScrolling.current.valForAccordian,
                  ]}
                  alwaysOpen
                  className="theme-custom-accordions item-customization-acc"
                >
                  <Accordion.Item eventKey={`${index}`}>
                    {accordionHeader({ index, label, ingredients })}
                    {accordionBody(ingredients)}
                  </Accordion.Item>
                </Accordion>
              </Container>
            ) : null}
          </React.Fragment>
        );
      }
    );

  const otherModifierJSXWithCustomAccordionControl: JSX.Element =
    modifierGroups && (
      <Accordion
        className="theme-custom-accordions item-customization-acc"
        activeKey={openAccordions}
      >
        {modifierGroups.map(
          (ingredients: IModifierGroups, index: number): JSX.Element => {
            const label: string = ingredients?.label?.toLowerCase();
            return (
              <React.Fragment key={ingredients.id}>
                {showGroup(ingredients) ? (
                  <Container fluid>
                    <Accordion.Item eventKey={`${index}`} key={index}>
                      <span
                        onClick={() =>
                          handleToggle(
                            ingredients.id,
                            index.toString(),
                            'accordion'
                          )
                        }
                      >
                        {accordionHeader({ index, label, ingredients })}
                      </span>
                      {accordionBody(ingredients)}
                    </Accordion.Item>
                  </Container>
                ) : null}
              </React.Fragment>
            );
          }
        )}
      </Accordion>
    );

  function accordionHeader({
    index,
    label,
    ingredients,
  }: {
    index: number;
    label: string;
    ingredients: IModifierGroups;
  }): JSX.Element {
    return (
      <Accordion.Header>
        <span
          className="d-block text-capitalize f-sm-s18"
          ref={
            isCreateYourOwnItem
              ? (el) =>
                  (modifierGroupScrolling.current.refsToCYOIAddOnsModifier[
                    index
                  ] = el)
              : null
          }
        >
          {label}
          <span className="f-s13 f-w6 font-rale clr-dark-grey d-block lh-normal">
            {isCreateYourOwnItem && ingredients.max > 0 && (
              <span className="caption fs-14">{ingredients.max} Included</span>
            )}
          </span>
        </span>
      </Accordion.Header>
    );
  }

  function accordionBody(ingredients: IModifierGroups): JSX.Element {
      // Inline styles for JSON-like display
  const jsonContainerStyle = {
    fontFamily: 'Consolas, Monaco, "Courier New", monospace',
    fontSize: '13px',
    backgroundColor: '#f6f8fa',
    border: '1px solid #d0d7de',
    borderRadius: '6px',
    padding: '6px 12px',
    lineHeight: '1.5',
    display: "flex",
    width: "fit-content",
    marginBottom: "16px",
  };

  const braceStyle = {
    color: '#24292f',
    fontWeight: 'bold',
  };

  const keyStyle = {
    color: '#0550ae',
    fontWeight: '600',
  };

  const valueStyle = {
    color: '#0a3069',
  };

  const punctuationStyle = {
    color: '#57606a',
  };
    return (
      <Accordion.Body>
        {isUserAuthorizedForTestingPayload() && (
          <span style={jsonContainerStyle}>
            <span style={braceStyle}>{"{ "}</span>
            <span style={keyStyle}>base</span>
            <span style={punctuationStyle}>: </span>
            <span style={valueStyle}>{ingredients?.base ?? 0}</span>
            <span style={punctuationStyle}>, </span>
            <span style={keyStyle}>max</span>
            <span style={punctuationStyle}>: </span>
            <span style={valueStyle}>{ingredients?.max ?? 0}</span>
            <span style={punctuationStyle}>, </span>
            <span style={keyStyle}>min</span>
            <span style={punctuationStyle}>: </span>
            <span style={valueStyle}>{ingredients?.min ?? 0}</span>
            <span style={punctuationStyle}>, </span>
            <span style={keyStyle}>extendable_limit</span>
            <span style={punctuationStyle}>: </span>
            <span style={valueStyle}>{ingredients?.extendable_limit ?? 0}</span>
            <span style={braceStyle}>{" }"}</span>
          </span>
        )}

        <div className="single-item-modifiers">
          <ItemModifierGroups
            ingredients={ingredients}
            selectedAddOns={selectedAddOns}
            selectedCore={selectedCore}
            handleClick={(
              currentModifier: IParams,
              modifiers: IModifierGroups,
              type: string
            ) =>
              handleModifierClick(currentModifier, modifiers, type, ingredients)
            }
            isLimitExceed={isLimitExceed}
            isCreateYourOwnItem={isCreateYourOwnItem}
            isItEdit={isItEdit}
            showCustomization={showCustomization}
            noGrid={true}
            itemModifierItemModalWidth={itemModifierItemModalWidth}
          />
        </div>
      </Accordion.Body>
    );
  }

  function handleModifierClick(
    currentModifier: IParams,
    modifiers: IModifierGroups,
    type: string,
    ingredients
  ): void {
    const modifier = {
      ...currentModifier,
      ...{
        modifier_group_id: ingredients?.id,
        modifier_group_max: ingredients?.max,
        modifier_group_base: ingredients?.base,
      },
    };
    handleClick(modifier, modifiers, type);
  }

  function showGroup(ingredients: IModifierGroups): boolean {
    if (
      ingredients.modifiers_groups_modifiers.length <= 0 ||
      ingredients?.name?.toLowerCase().includes(DO_NOT_SHOW)
    ) {
      return false;
    } else {
      return true;
    }
  }

  return {
    otherModifierJSXWithByDefaultAccordionControl,
    otherModifierJSXWithCustomAccordionControl,
  };
};

export default ModifierGroups;
